import api from './api';

export default {
  async getCurrentUser(): Promise<any> {
    return api.get('/user', { withCredentials: true });
  },

  async changePassword(oldPassword: string, newPassword: string): Promise<any> {
    return api.post(
      '/user/change-password',
      {
        oldPassword,
        newPassword,
      },
      { withCredentials: true },
    );
  },
};
